import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import gameInformationReducer, {
  initial_information,
} from "./GameInformation/GameInformationReducer";
import playerStatInformationReducer, {
  initial_ps_information,
} from "./PlayerStatsInformation/PlayerStatInformationReducer";
import lineupReducer from "./Lineup/LineupReducer";
import { initial_lineup_information } from "./Lineup/LineupReducer";

import uamReducer, { initialUAMInfo } from "./UAM/UAMReducer";
import { combineReducers } from "redux";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import createMigrate from "redux-persist/es/createMigrate";
import blogReducer from "./Blog/BlogReducer";
import remoteConfigReducer from "./RemoteConfig/RemoteConfigReducer";
const rc_migrations = {
  0: (state) => {
    return {
      ...state,
    };
  },
};
const ps_migrations = {
  0: (state) => {
    return {
      ...state,
      ps_credits: false,
      ps_sellBy: false,
      ps_projVal: false,
      ps_valYear: false,
      ps_valL4: false,
      player_responsibility: "P",
    };
  },
};
const game_information_migrations = {
  0: (state) => {
    return {
      ...state,
      pl_res: "P",
    };
  },
  2: (state) => {
    return {
      ...state,
      ...initial_information,
    };
  },
  9: (state) => {
    return {
      ...state,
      sports: null,
      display_players: [],
      time_hours: 0,
      time_minutes: 0,
      time_seconds: 0,
      match_datetime: null,
    };
  },
};

if (
  process.env.REACT_APP_ENV === "production"
  // || process.env.REACT_APP_ENV === "development"
) {
  console.log = () => { };
  console.groupCollapsed = () => { };
  console.groupEnd = () => { };
  console.error = () => { };
}
const persistRemoteConfig = {
  key: "rc",
  storage,
  stateReconciler: hardSet,
  debug: true,
  version: 0,
  migrate: createMigrate(rc_migrations, { debug: true }),
  // blacklist: ["/home"],
};
const persistConfig = {
  key: "root",
  storage,
  stateReconciler: hardSet,
  debug: true,
  version: 9,
  migrate: createMigrate(game_information_migrations, { debug: true }),
  // blacklist: ["/home"],
};
const persistPSConfig = {
  key: "ps",
  storage,
  stateReconciler: hardSet,
  debug: true,
  // blacklist: ["/home"],
  version: 0,
  migrate: createMigrate(ps_migrations, { debug: true }),
};
const persistBlogConfig = {
  key: "blog",
  storage,
  stateReconciler: hardSet,
  debug: true,
  // blacklist: ["/home"],
};
const persistUserConfig = {
  key: "user",
  storage,
  stateReconciler: hardSet,
  debug: true,
  // blacklist: ["/home"],
};

const store_init = {
  gameInformationReducer: initial_information,
  uamReducer: initialUAMInfo,
  playerStatInformationReducer: initial_ps_information,
  lineupReducer: initial_lineup_information,
  blogReducer: blogReducer,
  rcReducer: remoteConfigReducer,
};

const combinedReducer = combineReducers({
  uamReducer: persistReducer(persistUserConfig, uamReducer),
  gameInformationReducer: persistReducer(persistConfig, gameInformationReducer),
  // gameInformationReducer: gameInformationReducer,
  playerStatInformationReducer: persistReducer(
    persistPSConfig,
    playerStatInformationReducer
  ),
  lineupReducer: lineupReducer,
  blogReducer: persistReducer(persistBlogConfig, blogReducer),
  rcReducer: persistReducer(persistRemoteConfig, remoteConfigReducer),
});
// const persistedReducer = persistReducer(persistConfig, combinedReducer);
// const store = createStore(gameInformationReducer, initial_information);
export let store = createStore(
  combinedReducer,
  store_init,
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true })
);

export let persistor = persistStore(store);
